<div class="ab-list-item-inner flex w-100 activity-type--upload">
  <span class="ab-list-item__icon">
    <span class="ab-fa-stacked--v2">
      <i class="icon fal fa-pen-to-square ab-stacked-icon"></i>
      <i class="icon fal fa-comment-minus ab-stacked-icon with-shadow--white"></i>
    </span>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span>
      removed responses from {{payload.entitiesAffected}} entities using bulk edit.
    </div>
    <div class="details">
      <div class="ab-list-group">
        <div class="ab-list-item pt-0050 pb-0050"
             *ngFor="let tag of removedTags">
          <i class="fal fa-tag color--turq"></i>
          <div class="ml-0050">
            <strong class="d-block">{{ tag | tagSelectLabel }}</strong>
            <span class="caps color--gray txt-12">
              <app-type-name-label [type]="tag.targetType"></app-type-name-label> >
              {{ tag?.category?.groupName }} >
              {{ tag?.category?.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
